/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * CustomerPolicy.tsx
 */

import Policy from "../tools/provider/Policy";

export default class CustomerPolicy implements Policy {
    /**
     * canSeeUsers
     * @returns {boolean}
     */
    public canSeeUsers(): boolean {
        return false;
    }
}